import useAuth from "./useAuth";
import { termsFor } from "../terms";

/**
 * Kliniğin terim seti (Hasta/Danışan, Muayene/Görüşme, Doktor/Uzman).
 * Yalnız klinik paneli ekranlarında kullanılır; admin paneli, e-postalar ve
 * denetim günlüğü "Hasta" kalır. Kaynak: oturumdaki klinik (`auth.clinic.termSet`).
 */
export default function useTerms() {
  const { auth } = useAuth();
  return termsFor(auth?.clinic?.termSet);
}
